import React from 'react'
import { Button, Form, Input } from 'antd'
import { Trans, useLingui } from '@lingui/react/macro'

import LabelItem from '../../../LabelItem'
import { formCls } from '../../classes'
import UserEntryFormContainer from '../../../UserEntryFormContainer'

import type { ISignUpStepProps } from '..'

import { CssIcon } from '@/components/CssIcon'
import GoogleUserButton from '@/pages/tad.ai/_components/GoogleUserButton'
import StyledButton from '@/pages/tad.ai/_components/StyledButton'
import FormItemEmail from '@/_blocks/Auth/FormItemEmail'


import { useRouter } from '@/hooks/routes';
import { cls, tw } from 'tagged-classnames-free';
import Link from '@/components/Link';
export interface IStep0Props extends ISignUpStepProps {
  className?: string
}

const Step0: React.FC<IStep0Props> = (props) => {
  const {
    countdownSendCode,
    // onNext,
    loading,
    handleClickLogIn,
    titleAs,
    formContainerClassName,
    readOnlyEmail,
    sendEmailVerifiedCode,
    handleVerify,
    isLoadingSendEmailVerifiedCode,
  } = props

  const { t } = useLingui()

  const form = Form.useFormInstance()
  const router = useRouter()

  // useEffect(() => {
  //   console.log(loading, 'loading')
  // }, [loading])

  const onNext = () => {
    handleVerify()
  }

  return (
    <UserEntryFormContainer
      title={<Trans>Sign up to get 25 FREE credits</Trans>}
      titleAs={titleAs}
      className={formContainerClassName}
      // titleClassName='mb-1'
      descClassName=''
      // description={<Trans>Enter your email address below to sign up.</Trans>}
    >
      <div className={formCls}>
        <GoogleUserButton className='mx-auto mb-8 w-full'>
          <Trans>Sign up with Google</Trans>
        </GoogleUserButton>
        <FormItemEmail
          readOnly={!!readOnlyEmail}
          preserve
          onClickEnter={(event) => {
            event.stopPropagation()
            event.preventDefault()
          }}
          inputClassName={cls`
            rounded-[6px]
          `}
          label={
            <LabelItem>
              <Trans>Email address</Trans>
            </LabelItem>
          }
        />
        <Form.Item
          name='code'
          label={
            <LabelItem>
              <Trans>Verification code</Trans>
            </LabelItem>
          }
          required={false}
          rules={[
            {
              required: true,
              message: t`Please input your code.`,
            },
          ]}
        >
          <Input
            placeholder={t`Enter code`}
            className='h-12'
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                event.stopPropagation()
                event.preventDefault()
                onNext?.()
              }
            }}
            suffix={
              <StyledButton
                className={cls`
                  text-sm font-normal
                `}
                loading={isLoadingSendEmailVerifiedCode}
                disabled={!!countdownSendCode}
                onClick={async (event) => {
                  event.preventDefault()
                  event.stopPropagation()
                  await form.validateFields(['email'])
                  sendEmailVerifiedCode?.()
                }}
              >
                {countdownSendCode ? (
                  <Trans>Resend {`${countdownSendCode} s`}</Trans>
                ) : (
                  <Trans>Send code</Trans>
                )}
              </StyledButton>
            }
          />
        </Form.Item>
        <Button
          onClick={() => {
            onNext?.()
          }}
          type='primary'
          block
          className={tw`
            group
            my-8
            flex h-12 w-full items-center justify-center gap-x-1 font-semibold
          `}
          loading={loading}
          // disabled={!!countdownSendCode}
        >
          <p>
            <Trans>Continue</Trans>
          </p>
          <CssIcon
            className={cls`
              i-com--right-arrow size-6 transition-transform group-hover:translate-x-1
            `}
          />
        </Button>
        {!readOnlyEmail ? (
          <p className='mb-3 text-center text-sm'>
            <Trans>Already have an account?</Trans>{' '}
            <span
              className='text-f-primary hover:text-f-primary-hover cursor-pointer'
              onClick={() => {
                if (handleClickLogIn) {
                  handleClickLogIn()
                } else {
                  router.push('/sign-in')
                }
              }}
            >
              <Trans>Sign in here</Trans>
            </span>
          </p>
        ) : null}

        <div
          className={cls`
            text-center text-sm
          `}
        >
          <Trans>By signing up, you agree to our </Trans>
          <Link
            target='_blank'
            href='/terms'
            rel='nofollow noreferrer'
            className='text-f-primary hover:text-f-primary-hover'
          >
            <Trans>Terms of Service</Trans>
          </Link>{' '}
          <Trans>and</Trans>{' '}
          <Link
            target='_blank'
            href='/privacy'
            rel='nofollow noreferrer'
            className='text-f-primary hover:text-f-primary-hover'
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </UserEntryFormContainer>
  )
}

export default Step0
